import { useEffect, useMemo, useState } from 'react';
import GlobalTableGenerator from '../../../../components/GlobalTableGenerator';
import FilterSection from '../TopCardOverview/FilterSection';
import { typeOfStudent } from '../../../../utils/constants/GlobalStaticData';
import dayjs from 'dayjs';
import { Paper, Stack } from '@mui/material';
import { useDispatch } from 'react-redux';
import { getRefundProjectTable } from '../../../../redux/features/refundSlice';
import { useSelector } from 'react-redux';

const TableJSON = [
  {
    field: 'project_name',
    headerName: 'Project',
    width: 180,
  },
  {
    field: 'total_refund_request_count',
    headerName: 'Total Refund Request Raised Count',
    width: 260,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'total_refund_request_amount',
    headerName: 'Total Refund Request Amount',
    width: 260,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'approved_count',
    headerName: 'Approved Count',
    width: 160,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'approved_amount',
    headerName: 'Approved Amount',
    width: 180,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'rejected_count',
    headerName: 'Rejected Count',
    width: 160,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'rejected_amount',
    headerName: 'Rejected Amount',
    width: 180,
    align: 'center',
    headerAlign: 'center',
  },
];

export default function RefundProjectTable() {
  const [showFilters, setShowFilters] = useState(true);
  const [selectedType, setSelectedType] = useState(typeOfStudent[0]);
  // const [projectId, setProjectId] = useState('');
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD')); //DEFAULT SET TO CURRENT MONTH STARTING DATE TO ENDING DATE
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));

  const dispatch = useDispatch();

  const { data, projectTableLoading } = useSelector((state) => state.refund.refundProjectTable);

  const dispatchParams = useMemo(() => {
    return {
      fromDate,
      toDate,
      type: selectedType?.id,
      // projectId,
    };
  }, [fromDate, toDate, selectedType]);

  useEffect(() => {
    dispatch(getRefundProjectTable(dispatchParams));
  }, []);

  const filterSubmit = () => {
    dispatch(getRefundProjectTable(dispatchParams));
  };

  return (
    <Stack>
      <FilterSection
        showFilters={showFilters}
        setShowFilters={setShowFilters}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        // projectId={projectId}
        // setProjectId={setProjectId}
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
        filterSubmit={filterSubmit}
        loading={false}
      />
      <Paper mt={1} elevation={4}>
        <GlobalTableGenerator
          columns={TableJSON}
          rows={data}
          TableStyle={{
            minWidth: 1000,
            borderCollapse: 'collapse',
            '& .MuiTableCell-root': {
              border: '1px solid #d9d9d9',
            },
          }}
          TableHeadStyle={{
            bgcolor: '#3a79bb',
            '& .MuiTableCell-root': {
              color: '#fff',
              fontWeight: 600,
            },
          }}
          loading={projectTableLoading}
        />
      </Paper>
    </Stack>
  );
}
